module.exports = __webpack_public_path__ + "img/border.7f639498.png";